/* MTT — Panier : produits vendus au pied linéaire.
   Les lignes ajoutées depuis la fiche « pied linéaire » portent la propriété cachée _mtt_pl.
   Pour ces lignes : la quantité (= nombre de pieds) n'est pas modifiable dans le panier,
   on affiche « Coupe sur mesure : X pi de long » et le prix unitaire « / pied linéaire ». */
(function () {
  var cache = null;
  var lastFetch = 0;

  function fetchCart() {
    var now = Date.now();
    if (cache && now - lastFetch < 1500) return Promise.resolve(cache);
    lastFetch = now;
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cache = c; return c; })
      .catch(function () { return null; });
  }

  function decorate(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, idx) {
      if (!item.properties || !item.properties._mtt_pl) return;
      var rows = document.querySelectorAll('#CartItem-' + (idx + 1) + ', #CartDrawer-Item-' + (idx + 1));
      rows.forEach(function (row) {
        var qtyInput = row.querySelector('quantity-input');
        if (qtyInput && !qtyInput.dataset.mttHidden) {
          qtyInput.dataset.mttHidden = '1';
          qtyInput.style.display = 'none';
        }
        var label = row.querySelector('.mtt-cart-coupe');
        var text = 'Coupe sur mesure : ' + item.quantity + ' pi de long';
        if (!label) {
          label = document.createElement('p');
          label.className = 'mtt-cart-coupe';
          label.style.cssText = 'margin:0 0 0.6rem;font-weight:600;';
          var wrap = qtyInput ? qtyInput.parentElement : row.querySelector('.cart-item__quantity');
          if (wrap) wrap.insertBefore(label, wrap.firstChild);
        }
        if (label && label.textContent !== text) label.textContent = text;
        row.querySelectorAll('.cart-item__details .product-option').forEach(function (opt) {
          if (opt.dataset.mttUnit) return;
          if (/\d/.test(opt.textContent) && /\$/.test(opt.textContent) && !opt.querySelector('dt')) {
            opt.dataset.mttUnit = '1';
            opt.appendChild(document.createTextNode(' / pied linéaire'));
          }
        });
      });
    });
  }

  function run() {
    if (!document.querySelector('cart-items, cart-drawer-items, .cart-item')) return;
    fetchCart().then(decorate);
  }

  document.addEventListener('DOMContentLoaded', run);
  setInterval(function () { cache = null; run(); }, 1500);
})();

/* MTT — Cartes produit des tapis avec bordure (/products/deluxe-rib-mat-avec-bordure-…).
   Le prix réel de chaque format inclut la bordure ; sur la carte on affiche plutôt
   « prix au pied / pi lin. + bordure (dès X $) », calculé à partir des prix des variantes
   (plus petite largeur : écart entre 4 et 5 pi = prix au pied ; le reste = bordure). */
(function () {
  var memo = {};
  function fmt(c) { return (c / 100).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' }); }
  function regle(p) {
    var par = {};
    p.variants.forEach(function (v) { (par[v.option1] = par[v.option1] || []).push({ L: parseFloat(v.option2), prix: v.price }); });
    var w = Object.keys(par).sort(function (a, b) { return parseFloat(a) - parseFloat(b); })[0];
    var a = par[w].sort(function (x, y) { return x.L - y.L; });
    if (a.length < 2) return null;
    var pf = Math.round((a[1].prix - a[0].prix) / (a[1].L - a[0].L));
    return { pf: pf, bord: a[0].prix - a[0].L * pf };
  }
  function cartes() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.dataset.mttBd) return;
      var a = c.querySelector('a[href*="/products/deluxe-rib-mat-avec-bordure-"]');
      var prix = c.querySelector('.card-information .price');
      if (!a || !prix) return;
      c.dataset.mttBd = '1';
      var h = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
      var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      memo[h] = memo[h] || fetch(racine + 'products/' + h + '.js').then(function (r) { return r.json(); });
      memo[h].then(function (p) {
        var r = regle(p);
        if (!r || r.bord <= 0) return;
        prix.innerHTML = '<span class="mtt-bd-carte">À partir de ' + fmt(r.pf) + ' / pi lin. <span style="font-size:0.85em">+ bordure (dès ' + fmt(r.bord) + ')</span></span>';
      }).catch(function () { c.dataset.mttBd = ''; });
    });
  }
  document.addEventListener('DOMContentLoaded', cartes);
  setInterval(cartes, 1500);
})();

/* MTT — Cartes produit du prélart (/products/linoleum-…, /products/prelart-…, Cottage Chic, Serie S et T Tile).
   Le prix Shopify est celui d'un pied linéaire de rouleau ; sur la carte on affiche plutôt
   « X $/pi² · rouleau de L pi », avec le prix au pi² lu dans le titre et L = prix du pied ÷ prix au pi². */
(function () {
  var motif = /\/products\/(linoleum-|prelart-|cottage-chic-9836|serie-s-tile|serie-t-tile)/;
  function fmt(c) { return (c / 100).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' }); }
  function cartes() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.dataset.mttPr) return;
      var a = c.querySelector('a[href*="/products/"]');
      var prix = c.querySelector('.card-information .price');
      if (!a || !prix || !motif.test(a.getAttribute('href'))) return;
      var titre = (c.querySelector('.card__heading') || a).textContent;
      var m = titre.match(/(\d+(?:[.,]\d+)?)\s*\$\s*\/\s*(?:pi²|pi2|pc)/i);
      var regulier = prix.querySelector('.price__regular .price-item--regular') || prix.querySelector('.price-item--regular');
      if (!m || !regulier) return;
      var n = regulier.textContent.match(/(\d+(?:[.,]\d+)?)/);
      var pp = parseFloat(m[1].replace(',', '.')), pied = n ? parseFloat(n[1].replace(',', '.')) : NaN;
      if (!(pp > 0) || !(pied > 0)) return;
      var w = Math.round(pied / pp);
      if (w < 6 || w > 15) return;
      c.dataset.mttPr = '1';
      prix.innerHTML = '<span class="mtt-pr-carte">' + fmt(Math.round(pp * 100)) + ' / pi² <span style="font-size:0.85em">· rouleau de ' + w + ' pi</span></span>';
    });
  }
  document.addEventListener('DOMContentLoaded', cartes);
  setInterval(cartes, 1500);
})();